import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { CodelistRecord } from '../domain/codelistRecordSchema';
import { useEntries } from 'hooks/store';

export const useCreateCodelistRecordMutation = (
	args: {
		originalEntryId: string;
		projectId: string;
	},
	opts?: {
		enabled?: boolean;
	}
) => {
	const queryClient = useQueryClient();
	const [_, fetchEntries] = useEntries({ lazy: true, filtered: true });

	const invalidateCodelist = () => {
		queryClient.invalidateQueries({
			queryKey: ['codelist', args.originalEntryId, args.projectId]
		});
		queryClient.invalidateQueries({
			queryKey: ['latestDataEntryVersion']
		});
	};

	return useMutation({
		mutationKey: ['codelist', args.originalEntryId, args.projectId],
		mutationFn: (record: CodelistRecord) =>
			makeRequest({
				method: 'createCodelistRecord',
				service: 'cde',
				data: {
					projectId: args.projectId,
					entryId: args.originalEntryId,
					record: {
						...record
					}
				}
			}),
		onSuccess: () => {
			invalidateCodelist();
			fetchEntries();
		},

		retry: false,
		...opts
	});
};
